import React from 'react'
import { hashHistory } from 'react-router'
import Grid from '@material-ui/core/Grid'
import TableInc from '../../../shared-ui/TableInc'
import ButtonInc from '../../../shared-ui/ButtonInc'
import { formatDateLocale } from '../../../lib/utils.es6'
import { getPartner } from '../../../lib/access.es6'
import { formatPolicyStatusLabel } from '../../../lib/policyStatusEnum.es6'

function hasValue(value) {
  return value !== null && value !== undefined && value !== ''
}

// Beneficiary details count as captured when samba's beneficiary capture
// key is set — the same field the "Not captured" filter matches on,
// keeping the column and the filter consistent.
function isBeneficiaryCaptured(policy) {
  const details = policy.additional_details || {}
  return hasValue(details.next_of_kin_national_id)
}

const SambaRecentPolicies = props => {
  const partner = getPartner()
  const currencyCode =
    partner && partner.country && partner.country.currency_code
      ? partner.country.currency_code
      : ''

  const tempArr = (props.policies || [])
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map(policy => {
      const details = policy.additional_details || {}
      const subscriber = [
        details.subscriber_first_name,
        details.subscriber_surname
      ]
        .filter(Boolean)
        .join(' ')
      return {
        ...policy,
        insured_display: details.insured_full_name || 'N/A',
        subscriber_display: subscriber || 'N/A',
        start_date_display: formatDateLocale(policy.start_date) || 'N/A',
        due_date_display: formatDateLocale(policy.due_date) || 'N/A',
        total_paid_display:
          typeof policy.total_paid_amount_in_cents === 'number'
            ? `${currencyCode} ${(
                policy.total_paid_amount_in_cents / 100
              ).toLocaleString()}`
            : 'N/A',
        beneficiary_captured: isBeneficiaryCaptured(policy)
      }
    })

  const columns = [
    {
      title: 'Policy Number',
      field: 'policy_number',
      render: rowData => (
        <span
          style={{
            fontFamily: 'monospace',
            color: '#2D3748',
            fontWeight: '500'
          }}
        >
          {rowData.policy_number || 'N/A'}
        </span>
      )
    },
    { title: 'Insured', field: 'insured_display' },
    { title: 'Subscriber', field: 'subscriber_display' },
    {
      title: 'Status',
      field: 'status',
      render: rowData => formatPolicyStatusLabel(rowData.status) || 'N/A'
    },
    { title: 'Subscription Date', field: 'start_date_display' },
    { title: 'Next Payment Due', field: 'due_date_display' },
    { title: 'Total Paid', field: 'total_paid_display' },
    {
      title: 'Beneficiary Captured',
      field: 'beneficiary_captured',
      render: rowData => (rowData.beneficiary_captured ? 'Yes' : 'No')
    },
    {
      title: 'Actions',
      field: 'actions',
      render: rowData => (
        <ButtonInc
          onClick={() =>
            hashHistory.push(`admin/policy-processing/${rowData.policy_number}`)
          }
          variant="contained"
          sx={{ textTransform: 'none' }}
        >
          View Policy
        </ButtonInc>
      )
    }
  ]

  const handleTableChange = (newPage, pageSize) => {
    props.handleNextPage({
      page: newPage + 1,
      size: pageSize
    })
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} sm={12}>
        <TableInc
          columns={columns}
          data={tempArr}
          page={(props.page || 1) - 1}
          totalCount={props.total || 0}
          onChangePage={handleTableChange}
          localization={{
            body: {
              emptyDataSourceMessage: 'No policies match the selected filters'
            }
          }}
          options={{
            pageSize: props.size || 20,
            paging: true,
            showTitle: false,
            search: false,
            emptyRowsWhenPaging: false
          }}
        />
      </Grid>
    </Grid>
  )
}

export default SambaRecentPolicies
